import React from "react";
import {Button, FormCheck, Image} from "react-bootstrap";
import {url} from "../../utils/UrlsUtil.ts";
import {img} from "../../utils/ImageUtil.ts";
import {isNotEmpty} from "../../utils/CommonUtil.ts";

interface MyDesignCardPreviewProps {
    imagePath?: string;
    autoPreview?: boolean;
    addClassName?: string;
    handlePreview?: () => void;
    onChangeAutoPreview?: (checked: boolean) => void;
}
const MyDesignCardPreview: React.FC<MyDesignCardPreviewProps> = (
    {
        imagePath = "",
        autoPreview = true,
        addClassName = "",
        handlePreview,
        onChangeAutoPreview,
    }) => {

    return <div className={`my-design-preview ${addClassName}`}>
        <Button variant={"light"} disabled={autoPreview} onClick={handlePreview}>
            <Image src={url('/images/icon/preview_icon.png')} style={{marginLeft: '1rem'}}></Image>　設定でプレビューを表示する
        </Button>
        <FormCheck id="chkAutoPreview" type={"checkbox"} label={"自動プレビューを表示する"} checked={autoPreview} onChange={(e) => onChangeAutoPreview?.(e.target.checked)} />
        <div className="preview-image">
            <Image src={img(imagePath)} fluid={true} />
            {isNotEmpty(imagePath) && <div className="cutting-line"></div>}
        </div>
        {isNotEmpty(imagePath) && <p className="original-card-note text-danger">
            🔴赤枠は断裁線です。印刷時に最大2mmズレる可能性があります。<br/>
            ✅ 文字・ロゴ → 断裁線から 3mm以上内側に配置。<br/>
            ✅ 背景 → 断裁線から 3mm以上外側まで塗る。<br/>
            ❌ 断裁線ピッタリはNG（切れます）<br/>
            ※clocheの場合、カードの角丸加工は行いません。
        </p>}
    </div>;
};
export default MyDesignCardPreview;